import { shipmentManifest } from './shipment-manifest';
import { DocumentType } from '../../../enums/document-type';

export const batchShipmentManifest = {
  ...shipmentManifest,
  id: DocumentType.BatchShipmentManifest.identifier,
};
